module.exports = __webpack_public_path__ + "static/media/Step2.2916cbfd.jpg";